import * as React from "react";
import { Room, TwilioError } from "twilio-video";
import { makeLogger } from "../../utils/logger";

const log = makeLogger("Twilio - useHandleRoomDisconnection");
export function useHandleRoomDisconnection(
	room: Room | null,
	removeLocalAudioTrack: () => void,
	removeLocalVideoTrack: () => void,
	onError: (err: TwilioError) => void,
) {
	React.useEffect(() => {
		if (room) {
			log.debug("Init");
			const onDisconnected = (_: Room, error: TwilioError) => {
				if (error) {
					onError(error);
				}

				log.debug("Removing tracks");
				removeLocalAudioTrack();
				removeLocalVideoTrack();
			};

			room.on("disconnected", onDisconnected);
			return () => {
				room.off("disconnected", onDisconnected);
			};
		}
	}, [room, onError, removeLocalAudioTrack, removeLocalVideoTrack]);
}
